import React from "react";
import styled from "styled-components";
import { P } from "@etiquette-ui/typography";

const Container = styled.div`
  flex: 1;
  justify-content: center;
  align-items: center;
  display: flex;
`;

const EmptyText = styled(P)`
  color: white;
  font-size: 1.6rem;
`;

const NoDataAvailable: React.FC<{ className?: string }> = ({ className }) => {
  return (
    <Container className={className}>
      <EmptyText className={""}>No data available</EmptyText>
    </Container>
  );
};

export default NoDataAvailable;
